const PATH_PREFIX = '/messenger/:companyID';

export default [
  {
    name: 'messenger.chatrooms',
    path: `${PATH_PREFIX}/chatrooms`,
  },
  {
    name: 'messenger.chatroom',
    path: `${PATH_PREFIX}/chatroom/:chatroomID`,
  },
];
